// extracted by mini-css-extract-plugin
export default {"serviceItemWrapper":"ServiceItem_serviceItemWrapper__98Mp0","serviceImage":"ServiceItem_serviceImage__ryDv4","textContainer":"ServiceItem_textContainer__V6egF"};